import { render, staticRenderFns } from "./AnimeGridComponent.vue?vue&type=template&id=4a017bde&"
import script from "./AnimeGridComponent.vue?vue&type=script&lang=ts&"
export * from "./AnimeGridComponent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports